import React from 'react';
import { Alert as AntdAlert } from 'antd';
var InternalAlert = function InternalAlert(props) {
  return /*#__PURE__*/React.createElement(AntdAlert, props);
};
if (process.env.NODE_ENV !== 'production') {
  InternalAlert.displayName = 'Alert';
}
var Alert = InternalAlert;
Alert.ErrorBoundary = AntdAlert.ErrorBoundary;
export default Alert;